import { Component, Inject, OnInit, Optional } from '@angular/core';
import * as EmployeeModels from '@employee-models/index';
import { EmployeeBadgeRequestPageComponent } from './employee-badge-request-page.component';
import { BadgeReasonEnum, BadgeRequestCategoryEnum } from '@employee-models/data.enums';
import { IGuestRequest, IMemberVisitorFirmRequest, USI_REQUEST_TYPES } from './usi-employee-badge-forms';
import { BadgeRequestsService } from '../../core/services/data-access/badge-requests.service';
import { PhotoReviewService } from '../../core/services/data-access/photo-review.service';
import { ActivatedRoute, Router } from '@angular/router';
import { EmployeeBusinessService } from '../../core/services/business.service';
import { S3DeleteService } from '@ui-app/services/s3-delete.service';
import { AutomaticCroppingService, IAutoCropResultData } from '@ui-app/services/automatic-cropping.service';
import { FileUploadService } from '@ui-app/components/file-upload/file-upload.service';
import { UPLOAD_URL, UPLOAD_VISITOR_URL } from '@shared-models/common.models';
import { ImageService } from '@ui-app/services/image.service';
import { TAKE_PHOTO_SUBMIT, USER_RULES } from './user-rules';
import { IBadgeRequestModel, IBadgeRequestPhotoInfo, ICroppPhotoRequest, IMemberFirmRequest, INonDeloitteRequest, IThirdPartyContractorRequest } from '@employee-models/data.models';
import { catchError, combineLatest, filter, Observable, of, switchMap } from 'rxjs';
import { EReturnImageResizeType } from '@shared-models/common.enums';
import { Console } from 'console';
@Component({
  selector: 'employee-photo-compliance-request',
  templateUrl: './photo-compliance-request.component.html',
  styleUrl: './photo-compliance-request.component.less'
})
export class PhotoComplianceRequestComponent extends EmployeeBadgeRequestPageComponent implements OnInit {

  flowType = EmployeeModels.CE.BadgeRequestFlow.Compliance;
  isUserCanTakePhoto = true;
  canUseCurrentImage: boolean = false;
  userPhotoUrl: string = null;

  isLastPhotoApproved = false;
  BadgeReasons = BadgeReasonEnum;
  BadgeCategories = BadgeRequestCategoryEnum;
  formToSubmit: USI_REQUEST_TYPES;
  constructor(
    badgeRequestsService: BadgeRequestsService,
    photoReviewService: PhotoReviewService,
    router: Router,
    employeeBusinessService: EmployeeBusinessService,
    deleteFileService: S3DeleteService,
    automaticCroppingService: AutomaticCroppingService,
    imageService: ImageService,
    @Optional() @Inject(UPLOAD_URL) public uploadUrl: string,
    @Optional() @Inject(UPLOAD_VISITOR_URL) public uploadVisitorUrl: string,
    @Optional() @Inject(FileUploadService) public fileUploadService: FileUploadService,
    route: ActivatedRoute
) {
    super(badgeRequestsService,
        photoReviewService,
        router, employeeBusinessService, deleteFileService, automaticCroppingService, imageService, uploadUrl, uploadVisitorUrl, fileUploadService,route);
}

get reason(): number | null {
    return this.BadgeReasons.PhotoCompliance;
}

get category(): number | null {
    return this.requestReasonPayload?.category;
}

// Only applicable for USI Users
get isBadgeLostOrStolen(): boolean {
  console.log("isBadgeLostOrStolen");
    return this.checkRule && this.requestReasonPayload &&
        (this.requestReasonPayload.reason === BadgeReasonEnum.BadgeLost ||
            this.requestReasonPayload.reason === BadgeReasonEnum.BadgeStolen);
}

get checkRule(): boolean {
    return USER_RULES.passByCountry.countries.includes(this.userData.country);
}


get isNextDisabled(): boolean {
   
            return !this.canOpenTakePhotoStepper;
    

}

ngOnInit(): void {
    this.subs = this.getRequestDetailAction();
    this.subs = this.getUserDataAction();
    this.checkIsLastPhotoApproved();
    this.getCroppingSettings();
    this.setupCropImage();
    this.setupImageResize();
}

checkIsLastPhotoApproved(): void {
    if (this.checkRule) {
        this.subs = this.badgeRequestsService.isLastPhotoApproved().subscribe(data => this.isLastPhotoApproved = data);
    }
}

checkValidNextStep(event: EmployeeModels.CM.IBadgeRequestPayloadModel): void {
    if (this.isBadgeLostOrStolen && !this.isLastPhotoApproved) {
        this.employeeBusinessService.toasterService.error('Your photo is required.');
        this.canOpenTakePhotoStepper = false;
        return;
    }

    if ((!!event.bloodGroupId || !this.requestData.isBloodGroupRequired)
        && !!event.deliverySiteId
        && !!event.reason
    ) {
        this.requestReasonPayload = event;
        this.requestReasonPayload.isChanges = event.isChanges;
        this.requestData.siteId = event.deliverySiteId;
        this.requestData.bloodGroupId = event.bloodGroupId;
        this.canOpenTakePhotoStepper = true;
    }

    this.isUserCanTakePhoto = ![BadgeRequestCategoryEnum.ThirdPartyContractor, BadgeRequestCategoryEnum.NonDeloitte]
        .includes(this.requestReasonPayload.category);

}

uploadAction(file: IBadgeRequestPhotoInfo): void {
  console.log("uploadAction");
  console.log(this.reason);
    this.requestReasonPayload.isChanges = true;
    this.userPhotoUrl = file.url;
    this.userPhotoData = { uId: file.uId };
    this.requestReasonPayload.files = [file];
    this.isShowSubmitBtn = TAKE_PHOTO_SUBMIT[this.reason] || false;
    this.isShowNextBtn = !TAKE_PHOTO_SUBMIT[this.reason] || false;
    this.automaticallyCropTheImage$.next();
}

deletePhotoData(): void {
  console.log("deletePhotoData");
    this.deleteSubmitedFile();
    this.userPhotoData = null;
    this.userPhotoUrl = '';
    this.isCurrentPhotoUsed = false;
    this.requestReasonPayload.files = [];
    this.croppedPhotoSmallBase64 = null;
    this.croppedPhotoBase64 = null;
    this.cropperData = null;
    this.isShowSubmitBtn = false;
    this.isCanSubmit = false;
}

nextStep(): void {
  console.log("nextStep");
    if (this.requestReasonPayload.reason === BadgeReasonEnum.PhotoOnly) {
        this.canUseCurrentImage = false;
        if (this.isCurrentPhotoUsed) {
            this.deletePhotoData();
        }
    } else {
        this.canUseCurrentImage = this.requestData.canUseCurrentImage;
    }
    this.next();
}

idBadgeLostOrStoleFlow(payload: any): Observable<any> {
    return this.badgeRequestsService.saveUpload(payload);
}

isMemberVisitorFlow(payload: any): Observable<any> {
    return this.badgeRequestsService.saveUSIUpload(this.category, payload).pipe(
        // @ts-ignore
        switchMap((badgeRequestId: number[]) => {
            return this.croppMemberFirmGuestPhotos(this.formToSubmit as IMemberVisitorFirmRequest, badgeRequestId) as Observable<number[]>;
        })
    );
}

photoOnlyFlow(payload: any): Observable<any> {
  console.log("photoOnlyFlow");
    const { canvasData: { naturalWidth, naturalHeight } } = this.cropperData;
    payload.files[0] = { ...payload.files[0], height: naturalHeight, width: naturalWidth };

    const request: ICroppPhotoRequest = {
        badgeRequestId: null,
        croppInfo: JSON.stringify(this.cropperData),
        isAutocropped: true,
        uId: null
    };
    console.log(payload);
    console.log(request);
    return this.getSaveUploadStream(payload, request);
}

submit(): void {
  console.log("submit");
    if (!this.isCanSubmit) {
        return;
    }
    console.log(this.reason)
    this.requestReasonPayload.reason=this.BadgeReasons.PhotoOnly;
   
    this.requestReasonPayload.reason = this.BadgeReasons.PhotoCompliance;
    console.log(this.requestReasonPayload);
    const { reason, deliverySiteId, files, isPreferredFullName, bloodGroupId } = this.requestReasonPayload;
    const payload = { reason, deliverySiteId, files, isPreferredFullName, bloodGroupId };
    const payloadVisitor = { reason, files, isPreferredFullName };

    // TODO: remove any
    let request: Observable<any>;

    request = this.photoOnlyFlow(payload);
    

    this.subs = request.subscribe({
        next: (data) => {
            if (data?.message && data?.message?.includes('invalid')) {
                this.employeeBusinessService.toasterService.error(`The badge request wasn't created. Please refresh the page and try again`);
            } else {
                this.employeeBusinessService.toasterService.success('Badge request successfully submitted');
                this.openEmployeeProfile(this.userData.userId);
            }
        },

        error: (error) => {
            // Handle error response

            if (error.error && error.error.modelState && error.error.modelState.validationError) {
                var errMessage = error.error.modelState.validationError.system[0];
                if(errMessage.includes('compliance'))
                {
                    this.employeeBusinessService.toasterService.error(`A photo compliance request already exists for this user`);
                }
                else {
                    this.employeeBusinessService.toasterService.error(`The badge request wasn't created. Please refresh the page and try again`);    
                }
            }
            else{
                this.employeeBusinessService.toasterService.error(`The badge request wasn't created. Please refresh the page and try again`);
            }
        }

        //error: () => {
        //    this.employeeBusinessService.toasterService.error(`The badge request wasn't created. Please refresh the page and try again`);
        //}
    });
}


getSaveUploadStream(payload: IBadgeRequestModel | INonDeloitteRequest, request: ICroppPhotoRequest): Observable<any> {
    let saveRequest: Observable<number> = this.badgeRequestsService.saveUpload(payload as IBadgeRequestModel);
    console.log(saveRequest);
    console.log("getSaveUploadStream");
    console.log(this.reason);
   
    console.log(this.isImageRecognitionEnabled)
    if (this.isImageRecognitionEnabled) {
      console.log("isImageRecognitionEnabled if 1")
      console.log(this.isImageRecognitionEnabled)
        const uploadResizedPhoto$ = this.fileUploadService
            .uploadFile(
                this.imageService.fromDataUrlToFile(this.croppedPhotoSmallBase64, 'tmpFilename', this.imageService.imageDefaultType),
                this.isVisitorRequest ? this.uploadVisitorUrl : this.uploadUrl
            );
        return combineLatest([
            saveRequest,
            uploadResizedPhoto$
        ]).pipe(switchMap(([badgeRequestId, photoData]) => {
                return this.automaticCroppingService.cropPhoto({ ...request, badgeRequestId, uId: photoData.uId });
            })
        );
    }

    return saveRequest;
}

handleFormChange(formData: USI_REQUEST_TYPES): void {
  console.log("handleFormChange");
    this.resetNextStep();
    if (formData) {
        this.setSubmitAvailable();
        this.formToSubmit = formData;
    } else {
        this.formToSubmit = null;
    }
}

setSubmitAvailable(): void {
    this.isCanSubmit = true;
    this.isShowSubmitBtn = true;
}

resetNextStep(): void {
    this.isShowNextBtn = false;
    this.isCanSubmit = false;
}

getCroppingSettings(): void {
    this.subs = this.automaticCroppingService.getSetting().subscribe((settings) => {
        this.isImageRecognitionEnabled = settings.isImageRecognitionEnabled;
    });
}

setupCropImage(): void {
    this.subs = this.automaticallyCropTheImage$
        .pipe(
            filter(() => this.isImageRecognitionEnabled),
            switchMap(() => {
                    this.isCanSubmit = false;
                    return this.automaticCroppingService
                        .automaticallyCropTheImage(
                            this.userPhotoData.uId,
                            250,
                            375,
                            this.isVisitorRequest
                        )
                        .pipe(
                            catchError((() => {
                                this.deletePhotoData();
                                this.isCanSubmit = false;
                                return of(null);
                            })),
                            filter(x => !!x)
                        );
                }
            )).subscribe((croppedData: IAutoCropResultData) => {
            this.croppedPhotoBase64 = croppedData.croppedImageBase64;
            this.cropperData = croppedData.cropperData;
            this.isImageRecognitionEnabled = croppedData.isImageRecognitionEnabled;
            this.imageResize$.next();
        });
}

setupImageResize(): void {
    this.subs = this.imageResize$
        .pipe(switchMap(() => {
            return this.imageService.changeImageSize(
                this.imageService.fromDataUrlToFile(this.croppedPhotoBase64, 'tmpFilename'),
                this.imageService.imageDefaultType,
                600,
                EReturnImageResizeType.dataUrl,
                'tmpFilename'
            );
        })).subscribe((smallBase64: string) => {
            this.croppedPhotoSmallBase64 = smallBase64;
            this.isCanSubmit = TAKE_PHOTO_SUBMIT[this.reason] || false;
        });
}

// Removing croppInfo from request
adjustGuestPhotos(request: IMemberFirmRequest | IThirdPartyContractorRequest): any {
    const updatedForm = {
        ...request,
        // @ts-ignore
        guests: request.guests.map((guest: IGuestRequest) => {
            return {
                ...guest,
                photoInfo: guest.photoInfo.file,
                attachmentGuid: guest.attachmentGuid?.uId
            }
        })
    }
    return updatedForm as any;
}

croppMemberFirmGuestPhotos(request: IMemberVisitorFirmRequest, badgeRequestId: number[]): Observable<unknown> {
    const photos: ICroppPhotoRequest[] = [];
    request.guests.map((guest: IGuestRequest) => {
        photos.push({
            uId: guest.photoInfo.file.uId,
            badgeRequestId: null,
            croppInfo: guest.photoInfo.croppInfo,
            isAutocropped: false,
        });
    });
    badgeRequestId.map((id, index) => {
        photos[index].badgeRequestId = id
    })
    return this.photoReviewService.bulkCroppPhoto({ croppPhotos: photos });

}
}
